module.exports = __webpack_public_path__ + "img/ppt.3e4329eb.png";